<template>
  <div class="icon-card">
    <div class="header">
      <div class="icon" :style="{ backgroundImage: `url(${icon})` }"></div>
      <h4 class="title">{{ title }}</h4>
    </div>
  </div>
</template>

<script>
/* Reusable icon card component. */

export default {
  name: 'IconCard',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {},
  computed: {},
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.icon-card {
  width: 100%;
  padding: 1rem;
  border-radius: 9px;
  margin: 1rem 0;
  box-sizing: border-box;
  background-color: var(--light-brand-color);
  box-shadow: 0 4px 8px 0 $very-light-gray;
  display: flex;
  align-items: center;
  min-height: 6rem;
}
.header {
  display: flex;
  width: 100%;
  align-items: center;
}
.icon {
  height: 3rem;
  min-width: 3rem;
  max-width: 3rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.title {
  margin: 0 0 0 2rem;
}
</style>
